const DefaultContainer = () => import('@/containers/DefaultContainer');

const Settings = () => import('./index');
const ChangePassword = () => import('./components/ChangePassword');
const EditSetting = () => import('./components/EditSetting');

const settingsRoute = {
  path: '/settings',
  component: DefaultContainer,
  children: [
    {
      path: '/changepassword',
      name: '',
      component: ChangePassword
    },
    {
      path: '',
      name: 'SettingList',
      component: Settings
    },
    {
      path: ':id',
      name: 'EditSetting',
      component: EditSetting
    },
    {
      path: 'add',
      name: 'AddSetting',
      component: EditSetting
    }
  ]
};

export default settingsRoute;
